import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const userDetailsData = createAsyncThunk('userDetails/fetchuserDetailsData', async (selectedChargerLink) => {
  try {
    const response = await api.get(`/${selectedChargerLink}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user details data:', error);
    throw error;
  }
});

const UserDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userDetailsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(userDetailsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(userDetailsData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default UserDetailsSlice.reducer;
